import { createRoot } from "react-dom/client";
import { App } from "./App";
import { DialogHost } from "./components/Dialog";

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <DialogHost />
  </>,
);
